import React, { useState } from "react";
import PropTypes from "prop-types";
import { MdLockOutline } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";

export default function PasswordInput({
	label,
	isRequired,
	error,
	register,
	name,
	placeholder,
	className = "",
	...rest
}) {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div>
			<label htmlFor={name} className="flex items-center gap-2 mb-1 text-lg text-gray-800">
				<MdLockOutline className="text-gray-500 size-6" />
				{label}
				{isRequired && <span className="text-red-800 text-[6px]">*</span>}
			</label>
			<div className="relative">
				<input
					{...register(name)}
					id={name}
					type={showPassword ? "text" : "password"}
					placeholder={placeholder}
					className={`w-full rounded-xl border border-gray-400 focus:outline-customer-primary py-3 pr-12 pl-4 text-xl sm:text-sm ${className}`}
					{...rest}
				/>
				<IoEyeOutline
					className={`absolute top-1/2 left-3 -translate-y-1/2 size-6 cursor-pointer ${showPassword ? "text-customer-primary" : "text-gray-400"
						}`}
					onClick={() => setShowPassword((prev) => !prev)}
				/>
			</div>
			{error && <p className="text-red-600 text-sm mt-1">{error.message}</p>}
		</div>
	);
}

PasswordInput.propTypes = {
	label: PropTypes.string.isRequired,
	isRequired: PropTypes.bool,
	error: PropTypes.shape({
		message: PropTypes.string,
	}),
	register: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	className: PropTypes.string,
};

